import DTM, { PAGE_TYPE, EVENTS } from "shared/helpers/DTM";

const CHANNEL = "NDS";

export const onPageLoad = (isInternational = false) => {
    const data: { [key: string]: string | boolean } = {};
    data.pagetype = PAGE_TYPE.HOMEPAGE;
    data.pagename = `${CHANNEL} : ${PAGE_TYPE.HOMEPAGE}`;
    data.channel = CHANNEL;
    data.eventName = EVENTS.HOMEPAGE;
    data.isInternational = isInternational;
    DTM.onPageLoad(data);
};
